import Vue from 'vue'
import Vuex from 'vuex'
import salesModule from "@/store/modules/Sale/sales-module";
import emailModule from "@/store/modules/Sale/email-module"
import stockModule from "@/store/modules/Stock/stockmodule";
import stockCategories from "@/store/modules/Stock/stockcategory-module";
import tableModule from "@/store/modules/Sale/table-module";
import cookingInstruction from "@/store/modules/Sale/cookingInstruction";
import accounts from "@/store/modules/Accounts/accounts";
import kazangModule from "@/store/modules/Sale/kazang_module";
import timeModule from "@/store/modules/time-module";
import axios from "axios";
import {Storage} from "@/services/Storage"
import {responses} from "@/utils/responses";
import userModule from "@/store/modules/user_module";
import router from "@/router";

Vue.use(Vuex)
let CurrentTime = function () {
    let date = new Date();
    let d = date.toISOString().split('T')[0]
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let t = hour + ':' + minute + 'hrs';
    return d + ` at ` + t;
}
export default new Vuex.Store({
    state: {
        loading : false,
        zra_details: {},
        defaultStore: {},
        device_settings: {},
        baseCurrency: {Symbol: `K` , Rate : 1},
        lastUpdated: '',
        registeredStores : [],
        isUpdateAvailable : false,
        allStores : [],
    },
    getters: {
        getDefaultStore: (state) => state.defaultStore,
        getStores : (state) => state.allStores,
        getUpdateAvailability : (state) => state.isUpdateAvailable,
        getZRADetails: (state) => state.zra_details,
        getDeviceSettings: (state) => state.device_settings,
        getLasUpdated: (state) => state.lastUpdated,
        getBaseCurrency: (state) => state.baseCurrency,
        getRegisteredStores: (state) => state.registeredStores,
        getLoadingState: (state) => state.loading,
    },
    mutations: {
        setLoadingState: (state, payload) => state.loading = payload,        
        setUpdateAvailability : (state , payload) => state.isUpdateAvailable = payload,
        toggleNavigation: (state, width) => state.navigation = width,
        setRegisteredStores: async (state, data) => {
            if (!data) data = await Storage.getAllStores();
            else await Storage.setRegisteredStores(data);
            state.registeredStores = data
        },
        setAllStores : async (state,payload) => {
            if (!payload){
                let stores = await Storage.getAllStores();
                if (!stores){
                    let defaultStore = await Storage.getDefaultStore();
                    stores = [];
                    stores.push(defaultStore);
                }
                payload = stores;
            }else{
                await Storage.setAllStores(payload);
            }
            state.allStores = payload;
        },
        setZraDetails: async (state, data) => {
            state.zra_details = data
            await Storage.setZRADetails(data)
        },
        setLastUpdated: (state, payload) => state.lastUpdated = payload,
        setDeviceSettings: async (state, payload) => {
            if (payload) await Storage.setDeviceSettings(payload);
            else payload = Storage.getDeviceSettings();
            state.device_settings = payload
        },

        setBaseCurrency: async (state, payload) => {
            if (payload) await Storage.setBaseCurrency(payload);
            else payload = Storage.getBaseCurrency();
            state.baseCurrency = payload
        },

        setDefaultStore: (state, data) => {
            state.defaultStore = data
            return Storage.setDefaultStore(data)
        },
    },
    actions: {
        syncData: async ({dispatch, commit}) => {
            commit("setCurrentUser");
            return axios.all([
                dispatch('getAllUsers'),
                dispatch("getAllSecurities"),
                dispatch('getAllStock'),
                dispatch('getBaseCurrency'),
                dispatch('getDeviceSettings'),
                dispatch("getCategories"),
                dispatch("getAllStores"),
            ]).then(() => {
                commit("setCurrentUser");
                commit('setLastUpdated', CurrentTime())
            });

        },
        appLogin: (context, data) => {
            return axios.post(backOfficeTomcatApi+ 'mobileUser/login', data)
                .then(res => {
                    context.commit('setRegisteredStores', res.data)
                    return data;
                }).then(data => Storage.setAdminUser(data).catch(err => console.log(err)))
                .catch(err => {
                    let error = errorHandler.franchiseLoginError(err);
                    throw new Error(error)
                })
        },

        setDefaultStore: (context, data) => {
            context.commit('setDefaultStore', data)
            return context.dispatch('syncData')
        },

        loginToStore: async (context, payload) => {
            await context.commit(`setDefaultStore`, payload);
            await context.dispatch(`syncData`);
            let userCount = await context.getters.countNonLytSoftUsers;
            if (userCount === 0 || !userCount) {
                return router.push({name: 'create-initial-user'})
            }
            return router.push({name: 'poslogin'})
        },
        getDeviceSettings: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            let device = await Device.getDeviceId();
            return axios.get(serverApi + `settings/${store.StoreDB}/${device}`)
                .then(({data}) => context.commit('setDeviceSettings', data))
                .catch((err) => errorHandler.tomcatError(err))

        },

        saveSettings: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(`${serverApi}settings/${store.StoreDB}`, payload).then(({data}) => {
                context.commit('setDeviceSettings', data)
                return context.dispatch(`syncData`);
            }).catch((err) => errorHandler.tomcatError(err))
        },
        getStockLocations: async () => {
            let store = await Storage.getDefaultStore();
            return axios.get(`${serverApi}locations/${store.StoreDB}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        getAllStores: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi+`stores/getByGroup`,{
                params : { group : store.Group }
            }).then(({data})=>context.commit(`setAllStores`,data.sort((a, b) => a.StoreName.localeCompare(b.StoreName))));
        },
        getBaseCurrency: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `currency/${store.StoreDB}/getBaseCurrency`)
                .then(({data}) => context.commit('setBaseCurrency', data))
                .catch((err) => errorHandler.tomcatError(err))
        }
    },
    modules: {
        salesModule, stockModule, stockCategories, userModule,  tableModule, emailModule,
        cookingInstruction, accounts, kazangModule, timeModule
    }
})
